import { SystemOptionsListComponent } from '../ui/components/general/system-options/Components/system-options-list/system-options-list.component';
import { AddSystemOptionDialogComponent } from '../ui/components/general/system-options/Components/add-system-option-dialog/add-system-option-dialog.component';
import { SystemOptionComponent } from '../ui/components/general/system-options/Components/system-option/system-option.component';
import { SystemOptionsComponent } from '@ui/components/general/system-options/system-options.component';
import { PasswordTooltipComponent } from './../ui/components/password/password-tooltip/password-tooltip.component';
import { AgmCoreModule } from '@agm/core';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule, HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG, TransferState } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignaturePadModule } from 'angular2-signaturepad';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NullComponent } from '@base/component/NullComponent';
import { ServiceBagService } from '@base/component/ServiceBag';
import { M4UCardComponent } from '@ui/layouts/componentlayouts/card/card.component';
import { M4ULinkComponent } from '@ui/layouts/componentlayouts/link/link.component';
import { CollapsibleGroupComponent } from '@ui/layouts/componentlayouts/collapsible-group/collapsiblegroup.component';
import { GridButtonAddComponent } from '@ui/layouts/componentlayouts/grid-button-add/gridbuttonadd.component';
import { GridButtonRemoveComponent } from '@ui/layouts/componentlayouts/grid-button-remove/gridbuttonremove.component';
import { PageButtonsComponent } from '@ui/layouts/componentlayouts/page-buttons/pagebuttons.component';
import { FileBoxDialogComponent } from '@ui/dialogs/filebox-dialog/fileboxdialog.component';
import { InputBoxDialogComponent } from '@ui/dialogs/inputbox-dialog/inputboxdialog.component';
import { MessageBoxDialogComponent } from '@ui/dialogs/messagebox-dialog/messageboxdialog.component';
import { PhotoBoxDialogComponent } from '@ui/dialogs/photobox-dialog/photoboxdialog.component';
import { PrintBoxDialogComponent } from '@ui/dialogs/printbox-dialog/printboxdialog.component';
import { SelectBoxDialogComponent } from '@ui/dialogs/selectbox-dialog/selectboxdialog.component';
import { SignBoxDialogComponent } from '@ui/dialogs/signbox-dialog/signboxdialog.component';
import { SignBoxComponent } from '@ui/dialogs/signbox-dialog/signbox/signbox.component';
import { ImageBoxDialogComponent } from '@ui/dialogs/imagebox-dialog/imageboxdialog.component';
import { BarcodeBoxDialogComponent } from '@ui/dialogs/barcodebox-dialog/barcodeboxdialog.component';
import { M4UCustomBuildDirective } from '@ui/directives/CustomBuild';
import { FormatPriceWithCurrencyDirective, M4UConfigBooleanColumnDirective, M4UConfigEntitySourceDirectiveSelectBox, M4UConfigEntitySourceDirectiveTagBox, M4UConfigEntitySourceLookupColumn, M4UConfigMonthYearDirective, M4UConfigTimeDirective, M4UConfigYearDirective, M4UFieldEmptyDirective, M4UFieldLinkDirective, M4UFieldXEmptyDirective, M4UFormatCurrencyDirective, M4UFormatGeneralDirective, M4UFormatPercentDirective, M4UFormatPriceDirective, M4UFormatQuantityDirective, M4UFormatRateDirective, M4UFormatSumDirective, M4ULinkColumnDirective, M4UListWithPagination, M4UMultiEmailDirective } from '@ui/directives/Directives';
import { M4UConfigSearchDirective } from '@ui/directives/FormatSearch.directive';
import { M4URouterLinkEx, M4URouterLinkExWithHref } from '@ui/directives/Link.directive';
import { M4UViewContainerDirective } from '@ui/directives/ViewContainer.directive';
import * as pipes from '@ui/directives/Pipes';
import { FormatDateApproximatePipe, FormatDateAtTimePipe, FormatDateCompactPipe, FormatDatePipe, FormatDateShortPipe, FormatFullDateCompactPipe, FormatNumberGeneralPipe, FormatNumberPercentPipe, FormatNumberPricePipe, FormatNumberQuantityPipe, FormatNumberRatePipe, FormatNumberShortPipe, FormatNumberSumPipe, FormatTimePipe, HighlightPipe, LookupListPipe, LookupPipe, RCPipe, RCXPipe, SafePipe, YesEmptyPipe, YesNoPipe, YesNoPipeYN, StringBrPipe, FileSizePipe, RCMPipe, RCMXPipe, AbsPipe, FormatDayNamePipe, FormatDayNameShortPipe, FormatPriceWithCurrencyPipe } from '@ui/directives/Pipes';
import { M4URequiredDirectiveCheckBox, M4URequiredDirectiveColumn, M4URequiredDirectiveNumberBox, M4URequiredDirectiveSelectBox, M4URequiredDirectiveTextBox, M4URequiredDirectiveRadioGroup, M4URequiredDirectiveDateBox, M4URequiredDirectiveTextArea } from '@ui/directives/Required.directive';
import { ThrottleEventDirective } from '@ui/directives/ThrottleEvent.directive';
import { ExceptionComponent } from '@core/exceptions/exception.component';
import { FieldDetailComponent } from '@ui/layouts/fieldlayouts/field-detail/fielddetail.component';
import { FieldDetailComponentX } from '@ui/layouts/fieldlayouts/field-detailx/fielddetailx.component';
import { FieldFormComponent } from '@ui/layouts/fieldlayouts/field-form/fieldform.component';
import { FieldFormComponentX } from '@ui/layouts/fieldlayouts/field-formx/fieldformx.component';
import { SectionComponent } from '@ui/layouts/fieldlayouts/section/section.component';
import { DevExpressService } from '@core/framework/devexpress.service';
import { FrameworkService, OnInitializeFramework } from '@core/framework/framework.service';
import { HistoryEndpoint } from '@core/endpoints/history.endpoint';
import { GeneralEndpoint } from '@core/endpoints/general.endpoint';
import { GenericListEndpoint } from '@core/endpoints/genericlist.endpoint';
import { NativeNotificationsService } from '@core/framework/nativenotifications.service';
import { NavigatorService } from '@core/framework/navigator.service';
import { ResourcesService } from '@core/framework/resources.service';
import { ScreenService } from '@core/framework/screen.service';
import { SysEnumsService } from '@core/framework/sysenums.enum';
import { SysEventsService } from '@core/framework/sysevents.service';
import { SystemEndpoint } from '@core/endpoints/system.endpoint';
import { APIGatewayInterceptor } from '@core/gateway/APIGateway.intercept';
import { APIGatewayService } from '@core/gateway/APIGateway.service';
import { M4UConfigGridDirective, GridWrapperDirective } from '../base/grid/Grid.directive';
import { InjectorModule } from '@core/injector/injector.module';
import { AppComponent } from '@ui/layouts/layout/app.component';
import { EmptyLayoutComponent } from '@ui/layouts/layout/empty-layout/emptylayout.component';
import { MainLayoutComponent } from '@ui/layouts/layout/main-layout/mainlayout.component';
import { NavMenuComponent } from '@ui/layouts/layout/nav-menu/navmenu.component';
import { PageLayoutComponent } from '@ui/layouts/layout/page-layout/pagelayout.component';
import { ProgressPanelComponent } from '@ui/layouts/layout/progress-panel/progresspanel.component';
import { ToolbarComponent } from '@ui/layouts/layout/toolbar/toolbar.component';
import { ComingSoonComponent } from '@ui/components/login/coming-soon/comingsoon.component';
import { LoginComponent } from '@ui/components/login/login/login.component';
import { LogoutComponent } from '@ui/components/login/logout/logout.component';
import { SessionExpireComponent } from '@ui/components/login/session-expire/sessionexpire.component';
import { UsersActivityStatusComponent } from '@ui/components/general/user-activity-status/usersactivitystatus.component';
import { NotificationsHistoryComponent } from '@ui/notifications/notifications-history/notificationshistory.component';
import { NotificationViewComponent } from '@m4u-angular/ui/notifications/notifications-history/notification-view/notificationview.component';
import { NotificationGridComponent } from '@m4u-angular/ui/notifications/notifications-history/notification-grid/notificationgrid.component';
import { M4UStopClickPropagation } from '@ui/directives/Directives';
import { HistoryViewComponent } from '@m4u-angular/ui/components/general/history-view/historyview.component';
import { ArrayOrderByPipe } from '@ui/directives/Pipes';
import { M4UDevExpressModule } from './devexpress.module';
import { PasswordChangeComponent } from '@ui/components/password/password-change/passwordchange.component';
import { PasswordChangeExpiredComponent } from '@ui/components/password/password-change-expired/passwordchangeexpired.component';
import { PasswordRecoveryComponent } from '@ui/components/password/password-recovery/passwordrecovery.component';
import { PasswordWelcomeComponent } from '@ui/components/password/password-welcome/passwordwelcome.component';
import { LoginEndpoint } from '@core/endpoints/login.endpoint';
import { PasswordManageComponent } from '@ui/components/password/password-manage/passwordmanage.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { CaptchaComponent } from '@ui/layouts/componentlayouts/captcha/captcha.component';
import { AttachedFilesComponent } from '@ui/layouts/componentlayouts/attached-files/attached-files.component';
import { FileCardComponent } from '@ui/layouts/componentlayouts/attached-files/file-card/file-card.component';
import { M4USearchComponent } from '@ui/layouts/componentlayouts/search/search.component';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { M4ULoadingAnimationComponent } from '@ui/layouts/componentlayouts/loading-animation/loading-animation.component';
import { InjectedComponentsComponent } from '@ui/layouts/componentlayouts/injected-components/injected-components.component';
import { InjectedComponentsBaseService } from '@core/framework/injected-components-base.service';
import { AppRoutingModule } from './app-routing.module';
import { SessionService } from '@core/framework/session.service';
import { LoginGuard } from '@core/framework/login.guard';
import { ConfirmCancelGuard } from '@core/framework/confirm-cancel.guard';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environment/environment';
import { ExceptionHandler } from '@core/exceptions/exception.handler';
import { ENVIRONMENT } from '../environment/environment.model';
import { AppConfig, APP_CONFIG } from '@configuration/app.config.model';
import { AppConfigService } from '@configuration/app.config.service';
import { LoginService } from '@core/framework/login.service';
import { LoginByOtpComponent } from '@ui/components/login/login-by-otp/login-by-otp.component';
import { CommonSettingComponent } from '@ui/components/general/commonsettings/commonsetting.component';
import { CustomizationService } from '@core/framework/customization-service';
import { NotificationEndpoint } from '@core/endpoints/notification.endpoint';

import { FooterComponent } from '@ui/layouts/layout/footer/footer.component';

import { NestedOptionHost } from 'devextreme-angular';

import { TabsComponent } from '@ui/components/tabs/tabs.component';
import { LoginBaseComponent } from '@ui/components/login/base/login-base.component';

import { StatusColumnComponent } from '@ui/components/status-column/status-column.component';
import { ButtonComponent } from '@ui/components/button/button.component';
import { UserActivityStatusGridComponent } from '@ui/components/general/user-activity-status/grid/useractivitystatus-grid.component';

import { SessionExpiredComponent } from '@m4u-angular/ui/components/session-expired/session-expired.component';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { SystemOptionsService } from '@m4u-angular/core/framework/system-options.service';

import { SidebarModule } from 'primeng/sidebar';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { GridBottomContainerComponent } from '@ui/layouts/componentlayouts/grid-bottom-container/grid-bottom-container.component';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ToolbarModule } from 'primeng/toolbar';
import { PreviewDialogComponent } from '@ui/dialogs/preview-dialog/previewdialog.component';
//import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
//import { RouteReuseStrategy } from '@angular/router';
import { SplitterModule } from 'primeng/splitter';
import { StepsModule } from 'primeng/steps';
import { M4UConfigTextBoxTooltipDirective, M4UConfigTooltipDirective } from '@ui/directives/Tooltip.directive';
import { TooltipComponent } from '@ui/components/tooltip/tooltip.component';
import { M4UConfigViewPasswordDirective } from '@ui/directives/ViewPassword.directive';
import { PushMessageListComponent } from '@ui/notifications/push-message-list/push-message-list.component';
import { PushMessageBadgeComponent } from '@ui/notifications/push-message-badge/push-message-badge.component';
import { NotificationService } from '@core/framework/notification.service';
import { NotificationServerListComponent } from '@ui/notifications/notification-server/list/notification-server-list.component';
import { NotificationServerEndpoint } from '@core/endpoints/notification-server.endpoint';
import { NotificationServerGridComponent } from '@ui/notifications/notification-server/list/notification-server-grid/notification-server-grid.component';
import { NotificationTemplateListComponent } from '@ui/notifications/notification-template/notification-template-list/notification-template-list.component';
import { NotificationTemplateGridComponent } from '@ui/notifications/notification-template/notification-template-grid/notification-template-grid.component';
import { NotificationTemplateComponent } from '@ui/notifications/notification-template/notification-template.component';
import { NotificationTemplateEndpoint } from '@core/endpoints/notification-template.endpoint';
import { NotificationConfigurationBaseService } from '@core/framework/notification-configuration-base.service';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PushMessageComponent } from '@ui/notifications/push-message/push-message.component';
import { PushMessageToastsComponent } from '@ui/notifications/push-message-toasts/push-message-toasts.component';
import { EmailHistoryItemComponent } from '@ui/notifications/notifications-history/email-history-item/email-history-item.component';
import { PushMessageHistoryItemComponent } from '@ui/notifications/notifications-history/push-message-history-item/push-message-history-item.component';
import { SmsHistoryItemComponent } from '@ui/notifications/notifications-history/sms-history-item/sms-history-item.component';
import { HtmlBoxDialogComponent } from '@ui/dialogs/htmlbox-dialog/htmlbox-dialog.component';
import { EmailHistoryGridComponent } from '@ui/notifications/notifications-history/notification-grid/email-history-grid/email-history-grid.component';
import { SmsHistoryGridComponent } from '@ui/notifications/notifications-history/notification-grid/sms-history-grid/sms-history-grid.component';
import { PushMessageHistoryGridComponent } from '@ui/notifications/notifications-history/notification-grid/push-message-history-grid/push-message-history-grid.component';
import { PushMessageEndpoint } from '@core/endpoints/push-message.endpoint';
import { UiService } from '@core/framework/ui.service';
import { LOADING_BAR_CONFIG } from '@ngx-loading-bar/core';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NotificationTestDialogComponent } from '@ui/notifications/notification-test-dialog/notification-test-dialog.component';
import { NotificationPreviewDialogComponent } from '@ui/notifications/notification-preview-dialog/notification-preview-dialog.component';
import { NavBarComponent } from '@ui/layouts/layout/nav-bar/nav-bar.component';
import { MidStoreComponent } from '@m4u-angular/core/mid/mid-store.component';
import { AgmMarkerSpiderModule } from 'agm-spiderfier';
import { NotificationServerComponent } from '@ui/notifications/notification-server/notification-server.component';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { BottomSheetModule } from "swipe-bottom-sheet/angular";
import { BottomSheetService } from '@core/framework/bottom-sheet.service';
import { BottomSheetListComponent } from '@ui/components/bottom-sheet-list/bottom-sheet-list.component';
import { PushMessageListPopupComponent } from '@ui/notifications/push-message-list-popup/push-message-list-popup.component';
import { SideBarComponent } from '@ui/layouts/layout/side-bar/side-bar.component';
import { PageFilterComponent } from '@ui/layouts/layout/page-filter/page-filter.component';
import { SidebarService } from '@core/framework/sidebar.service';
import { PortalModule } from '@angular/cdk/portal';
import { PageToolbarButtonsComponent } from '@ui/layouts/componentlayouts/page-toolbar-buttons/page-toolbar-buttons.component';
import { GridToolbarComponent } from '@m4u-angular/ui/layouts/componentlayouts/grid-toolbar/grid-toolbar.component';
import { LanguageService } from '@core/framework/language.service';
import { SpinLoaderComponent } from '@ui/components/spin-loader/spin-loader.component';
import { BottomSheetContextMenuComponent } from '@ui/components/bottom-sheet-context-menu/bottom-sheet-context-menu.component';
import { DemoLayoutComponent } from "@ui/demo/layouts/demo-layout/demo-layout.component";
import { DemoButtonsComponent } from "@ui/demo/components/buttons/demo-buttons.component";
import { DemoNavbarComponent } from "@ui/demo/layouts/demo-navbar/demo-navbar.component";
import { DemoEditorsComponent } from "@ui/demo/components/editors/demo-editors.component";
import { DemoLayoutsComponent } from "@ui/demo/components/layouts/demo-layouts.component";
import { DemoSectionsComponent } from "@ui/demo/components/sections/demo-sections.component";
import { DemoCardsComponent } from "@ui/demo/components/cards/demo-cards.component";
import { DemoTabsComponent } from "@ui/demo/components/tabs/demo-tabs.component";
import { DemoGridsComponent } from "@ui/demo/components/grids/demo-grids.component";
import { DemoBottomSheetsComponent } from "@ui/demo/components/bottom-sheets/demo-bottom-sheets.component";
import { BaseGridComponent } from "@base/component/BaseGridComponent";
import { DemoGridComponent } from "@ui/demo/components/grids/grid/demo-grid.component";
import { DemoPagesComponent } from "@ui/demo/components/pages/demo-pages.component";
import {
    DemoPageToolbarButtonsComponent
} from "@ui/demo/components/pages/examples/toolbar-buttons/demo-page-toolbar-buttons.component";
import {
    DemoPageHeaderButtonsComponent
} from "@ui/demo/components/pages/examples/header-buttons/demo-page-header-buttons.component";
import { DemoSidebarsComponent } from "@ui/demo/components/sidebars/demo-sidebars.component";
import { DemoDialogsComponent } from "@ui/demo/components/dialogs/demo-dialogs.component";
import { DemoSimpleDialogComponent } from "@ui/demo/components/dialogs/simple-dialog/demo-simple-dialog.component";
import { DemoPipesComponent } from "@ui/demo/components/pipes/demo-pipes.component";
import { DemoComponentsComponent } from "@ui/demo/components/components/demo-components.component";
import { BreadcrumbComponent } from '@ui/components/breadcrumb/breadcrumb.component';
import { RouteHistoryService } from '@core/framework/route-history.service';
import { UserActivityEndpoint } from "@core/endpoints/useractivity.endpoint";
import { UserLoginHistoryComponent } from "@ui/components/general/user-login-history/user-login-history.component";
import {
    UserLoginHistoryGridComponent
} from "@ui/components/general/user-login-history/grid/user-login-history-grid.component";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PdfViewerComponent } from '@ui/components/pdf-viewer/pdf-viewer.component';
import { SliderModule } from 'primeng/slider';
import { RequestHistoryListComponent } from '@ui/components/general/request-history/request-history-list/request-history-list.component';
import { WebAPICredentialEndpoint } from '@core/endpoints/webapi-credential.endpoint';
import { RequestHistoryGridComponent } from '@ui/components/general/request-history/request-history-grid/request-history-grid.component';
import { WebAPIRequestEndpoint } from '@core/endpoints/webapi-request.endpoint';
import { RequestHistoryComponent } from '@ui/components/general/request-history/request-history.component';
import { WelcomeUserDialogComponent } from '@ui/components/password/password-manage/welcome-user-dialog/welcome-user-dialog.component';
import { HistoryViewGridComponent } from '@m4u-angular/ui/components/general/history-view/grid/historyview-grid.component';
import { TimelineModule } from 'primeng/timeline';
import { EntityService } from '@core/framework/entity.service';
import { TotalBalanceCardComponent } from '@ui/components/total-balance-card/total-balance-card.component';
import * as UIComponents from '@ui/components';

//Components to be used by application
export const ReusableComponents: any =
    [
        //Field layouts
        SectionComponent,
        FieldFormComponent,
        FieldFormComponentX,
        FieldDetailComponent,
        FieldDetailComponentX,

        //UI Enahncements
        M4UCardComponent,
        M4ULinkComponent,
        M4USearchComponent,
        PageButtonsComponent,
        CollapsibleGroupComponent,
        GridBottomContainerComponent,
        GridButtonAddComponent,
        GridButtonRemoveComponent,
        CaptchaComponent,
        AttachedFilesComponent,
        FileCardComponent,
        M4ULoadingAnimationComponent,
        TabsComponent,
        ButtonComponent,
        SessionExpiredComponent,
        TooltipComponent,
        ...Object.values(UIComponents),

        //Dialogs
        SelectBoxDialogComponent,
        InputBoxDialogComponent,
        MessageBoxDialogComponent,
        PrintBoxDialogComponent,
        SignBoxDialogComponent,
        SignBoxComponent,
        ImageBoxDialogComponent,
        PhotoBoxDialogComponent,
        FileBoxDialogComponent,
        PreviewDialogComponent,
        BarcodeBoxDialogComponent,
        WelcomeUserDialogComponent,

        //Main components
        AppComponent,
        NullComponent,
        PageLayoutComponent,

        //Misc directives
        M4UCustomBuildDirective,
        ThrottleEventDirective,
        M4URequiredDirectiveTextBox,
        M4URequiredDirectiveNumberBox,
        M4URequiredDirectiveSelectBox,
        M4URequiredDirectiveCheckBox,
        M4URequiredDirectiveRadioGroup,
        M4URequiredDirectiveDateBox,
        M4URequiredDirectiveColumn,
        M4URequiredDirectiveTextArea,
        M4URouterLinkEx,
        M4URouterLinkExWithHref,
        M4UStopClickPropagation,
        M4UFieldEmptyDirective,
        M4UFieldXEmptyDirective,
        GridWrapperDirective,
        M4UViewContainerDirective,

        //Format directives
        M4UConfigMonthYearDirective,
        M4UConfigYearDirective,
        M4UConfigTimeDirective,
        M4UFormatSumDirective,
        M4UFormatPriceDirective,
        M4UFormatQuantityDirective,
        M4UFormatPercentDirective,
        M4UFormatRateDirective,
        M4UFormatGeneralDirective,
        M4UFormatCurrencyDirective,
        M4UMultiEmailDirective,
        FormatPriceWithCurrencyDirective,

        //Config directives
        M4UConfigSearchDirective,
        M4UConfigGridDirective,
        M4UConfigEntitySourceDirectiveSelectBox,
        M4UConfigEntitySourceDirectiveTagBox,
        M4UConfigEntitySourceLookupColumn,
        M4UConfigBooleanColumnDirective,
        M4UConfigTooltipDirective,
        M4UConfigTextBoxTooltipDirective,
        M4UConfigViewPasswordDirective,
        M4UListWithPagination,
        M4UFieldLinkDirective,
        M4ULinkColumnDirective,

        //Pipes
        ...Object.values(pipes),
        ArrayOrderByPipe,
        SafePipe,
        StringBrPipe,
        FileSizePipe,
        AbsPipe,
        FormatPriceWithCurrencyPipe,
        CommonSettingComponent,

        StatusColumnComponent,
        SystemOptionComponent,
        AddSystemOptionDialogComponent,
        SystemOptionsListComponent,
        BottomSheetListComponent,
        BottomSheetContextMenuComponent,
        PageToolbarButtonsComponent,
        SpinLoaderComponent,
        BreadcrumbComponent,
        PdfViewerComponent,
        TotalBalanceCardComponent
    ];
//System components - no need to re-export
export const SystemComponents: any =
    [
        LoginBaseComponent,
        LoginComponent,
        LogoutComponent,
        SessionExpireComponent,
        PasswordChangeComponent,
        PasswordChangeExpiredComponent,
        PasswordRecoveryComponent,
        PasswordWelcomeComponent,
        ExceptionComponent,
        ComingSoonComponent,
        MainLayoutComponent,
        EmptyLayoutComponent,
        ToolbarComponent,
        ProgressPanelComponent,
        NavMenuComponent,
        NavBarComponent,
        UsersActivityStatusComponent,
        UserActivityStatusGridComponent,
        NotificationsHistoryComponent,
        NotificationViewComponent,
        NotificationGridComponent,
        EmailHistoryGridComponent,
        SmsHistoryGridComponent,
        PushMessageHistoryGridComponent,
        PushMessageListComponent,
        PushMessageListPopupComponent,
        PushMessageBadgeComponent,
        PushMessageComponent,
        PushMessageToastsComponent,
        EmailHistoryItemComponent,
        HtmlBoxDialogComponent,
        NotificationPreviewDialogComponent,
        NotificationTestDialogComponent,
        PushMessageHistoryItemComponent,
        SmsHistoryItemComponent,
        PasswordManageComponent,
        LoginByOtpComponent,
        InjectedComponentsComponent,
        FooterComponent,
        NotificationServerComponent,
        NotificationServerListComponent,
        NotificationServerGridComponent,
        NotificationTemplateListComponent,
        NotificationTemplateGridComponent,
        NotificationTemplateComponent,
        PasswordTooltipComponent,
        SystemOptionsComponent,
        MidStoreComponent,
        SideBarComponent,
        PageFilterComponent,
        GridToolbarComponent,
        UserLoginHistoryComponent,
        UserLoginHistoryGridComponent,
        RequestHistoryListComponent,
        RequestHistoryGridComponent,
        RequestHistoryComponent,
        HistoryViewComponent,
        HistoryViewGridComponent
    ];

const SystemEndpoints: any =
    [
        LoginEndpoint,
        GeneralEndpoint,
        GenericListEndpoint,
        SystemEndpoint,
        NotificationEndpoint,
        NotificationServerEndpoint,
        NotificationTemplateEndpoint,
        PushMessageEndpoint,
        UserActivityEndpoint,
        WebAPICredentialEndpoint,
        WebAPIRequestEndpoint,
        HistoryEndpoint
    ];

//System services - need to provide only
const SystemServices: any =
    [
        LoginGuard,
        ConfirmCancelGuard,
        LoginService,
        SessionService,
        APIGatewayService,
        DevExpressService,
        FrameworkService,
        SysEnumsService,
        ResourcesService,
        ServiceBagService,
        NativeNotificationsService,
        NavigatorService,
        SysEventsService,
        ScreenService,
        InjectedComponentsBaseService,
        AppConfigService,
        CustomizationService,
        NestedOptionHost,
        DeviceDetectorService,
        SystemOptionsService,
        NotificationService,
        NotificationConfigurationBaseService,
        UiService,
        MessageService,
        DialogService,
        BottomSheetService,
        SidebarService,
        LanguageService,
        RouteHistoryService,
        EntityService,
        TransferState,
        { provide: HTTP_INTERCEPTORS, useClass: APIGatewayInterceptor, multi: true },
        { provide: APP_INITIALIZER, useFactory: OnInitializeFramework, multi: true }
    ];

//Angular modules - need to re-export
const BuiltInModules: any =
    [
        BrowserModule,
        CommonModule,
        FormsModule,
        InjectorModule,
        HttpClientModule,
        BrowserAnimationsModule,
        M4UDevExpressModule,
        PdfJsViewerModule,
        SignaturePadModule,
        RecaptchaModule,
        LoadingBarHttpClientModule,
        InfiniteScrollModule,
        ScrollingModule,
        SidebarModule,
        CarouselModule,
        ButtonModule,
        InputNumberModule,
        ContextMenuModule,
        ToolbarModule,
        SplitterModule,
        StepsModule,
        SelectButtonModule,
        ToastModule,
        DynamicDialogModule,
        BottomSheetModule,
        ProgressSpinnerModule,
        TimelineModule,
        SliderModule
    ];

const DemoComponents: any =
    [
        DemoLayoutComponent,
        DemoNavbarComponent,
        DemoButtonsComponent,
        DemoEditorsComponent,
        DemoLayoutsComponent,
        DemoComponentsComponent,
        DemoSectionsComponent,
        DemoCardsComponent,
        DemoTabsComponent,
        DemoGridsComponent,
        DemoGridComponent,
        DemoBottomSheetsComponent,
        DemoPagesComponent,
        DemoPageToolbarButtonsComponent,
        DemoPageHeaderButtonsComponent,
        DemoSidebarsComponent,
        DemoDialogsComponent,
        DemoSimpleDialogComponent,
        DemoPipesComponent
    ];

let appConfig: AppConfig = AppConfigService.loadConfig();
let m4uConfig = AppConfigService.loadM4UConfig();

export function IsRegisterServiceWorker(): boolean {
    if (!environment.production) return false;
    if (location.protocol != 'https:') return false;
    if (!m4uConfig.isRegisterServiceWorker) return false;
    return true;
}

@NgModule({
    imports: [
        //IonicModule.forRoot(),
        BuiltInModules,
        AppRoutingModule,
        SidebarModule,
        PortalModule,
        AgmCoreModule.forRoot({ apiKey: m4uConfig.googleMapsApiKey }),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: IsRegisterServiceWorker() }),
        AgmMarkerSpiderModule
    ],
    declarations: [SystemComponents, ReusableComponents, m4uConfig.isDemoEnabled ? DemoComponents : [], ...appConfig.Components],
    entryComponents: appConfig.EntryComponents,
    exports: [BuiltInModules, AgmCoreModule, ReusableComponents],
    providers: [
        SystemEndpoints,
        SystemServices,
        { provide: ErrorHandler, useClass: ExceptionHandler },
        { provide: ENVIRONMENT, useValue: environment },
        { provide: LOCALE_ID, useValue: m4uConfig.defaultLocale ?? "he-IL" },
        //{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },

        { provide: APP_BASE_HREF, useValue: m4uConfig.deploymentApplicationFolder },
        { provide: APP_CONFIG, useValue: appConfig },
        { provide: LOADING_BAR_CONFIG, useValue: { latencyThreshold: 100 } },
        ...appConfig.Endpoints,
        ...appConfig.Services
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class M4UAngularModule {
}
